import { motion } from "framer-motion";
import { Megaphone, ShoppingCart, Printer, Search, Briefcase, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: Megaphone,
    title: "Agencia de Publicidad y Anuncios",
    desc: "Creación, diseño y distribución de campañas publicitarias de alto impacto en medios masivos y entornos digitales para posicionar tu marca.",
  },
  {
    icon: ShoppingCart,
    title: "Representación y Compra de Medios",
    desc: "Gestión y adquisición estratégica de espacios publicitarios impresos, digitales y audiovisuales a petición del cliente para maximizar el presupuesto.",
  },
  {
    icon: Printer,
    title: "Impresión y Material Publicitario",
    desc: "Servicios de impresión de formas continuas, editoriales y artículos promocionales con acabados de alta calidad para la identidad corporativa.",
  },
  {
    icon: Search,
    title: "Relaciones Públicas e Investigación de Mercados",
    desc: "Campañas de posicionamiento en medios, encuestas de opinión y estudios de mercado para comprender al consumidor y blindar la reputación de tu empresa.",
  },
  {
    icon: Briefcase,
    title: "Administración y Soporte Operativo",
    desc: "Servicios combinados de apoyo en instalaciones, cobranza especializada y soluciones de gestión interna para aligerar la carga administrativa empresarial.",
  },
];

export const Services = () => {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="bg-white py-24 sm:py-32 border-t border-[#BFBFBF]/40"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#BF1828] font-medium">
              Servicios de Simple Solutions
            </div>
            <h2
              data-testid="services-heading"
              className="mt-5 font-display font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1] text-black"
            >
              Soluciones integrales
              <br />
              para marcas que{" "}
              <span className="text-[#BF1828] italic font-light">crecen.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-body text-base sm:text-lg leading-relaxed text-[#595959]">
              Cada servicio está pensado para amplificar tu mensaje, conectar
              con tu audiencia y convertir la atención en resultados reales.
            </p>
          </div>
        </div>

        <div className="border-t border-[#BFBFBF]/60">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                data-testid={`service-row-${i + 1}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                className="group grid grid-cols-12 gap-4 sm:gap-6 py-8 sm:py-10 border-b border-[#BFBFBF]/60 hover:bg-[#F9F9F9] transition-colors duration-300 px-2 -mx-2"
              >
                <div className="col-span-12 sm:col-span-2 flex items-start">
                  <div className="w-12 h-12 border border-black flex items-center justify-center group-hover:bg-[#BF1828] group-hover:border-[#BF1828] transition-colors duration-300">
                    <Icon
                      size={20}
                      strokeWidth={1.6}
                      className="text-black group-hover:text-white transition-colors duration-300"
                    />
                  </div>
                </div>
                <div className="col-span-12 sm:col-span-6">
                  <h3 className="font-display font-semibold text-2xl sm:text-3xl leading-tight tracking-tight text-black group-hover:text-[#BF1828] transition-colors duration-300">
                    {s.title}
                  </h3>
                </div>
                <div className="col-span-12 sm:col-span-3">
                  <p className="font-body text-[15px] leading-relaxed text-[#595959]">
                    {s.desc}
                  </p>
                </div>
                <div className="col-span-12 sm:col-span-1 flex items-start justify-end">
                  <ArrowUpRight
                    size={28}
                    strokeWidth={1.4}
                    className="text-[#BFBFBF] group-hover:text-[#BF1828] group-hover:rotate-45 transition-all duration-300"
                  />
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
